// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"9f0c5667","455":"3d047698","977":"5faee6d4"}[chunkId] + ".chunk.js";
};